import React from "react";
import RecurringToDoList from "../../../component/TaskAssignment/RecurringToDoList";

const RecurringToDoListScreen = () => {
  return <div><RecurringToDoList /></div>;
};

export default RecurringToDoListScreen;
